<script setup>
	import { ref, computed, onMounted, onUnmounted } from "vue";

	const isMobile = ref(false);
	const tooltip = ref(null);
	const activeTooltip = ref(false);
	const tooltipParent = computed(() => tooltip.value?.parentNode);

	const showTooltip = (event) => {
		const parentTooltip = event.target;
		const child = parentTooltip.firstElementChild;
		activeTooltip.value = child.dataset.tooltip === parentTooltip.dataset.parentTooltip;
		child.style.top = `${parentTooltip.offsetHeight + 10}px`;
	};

	const hideTooltip = () => {
		activeTooltip.value = false;
	};

	const identifyMobileDevice = () => {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			isMobile.value = true;
		} else {
			isMobile.value = false;
		}
	};

	onMounted(() => {
		tooltipParent.value?.addEventListener("mouseover", showTooltip);
		tooltipParent.value?.addEventListener("mouseout", hideTooltip);
		tooltipParent.value?.addEventListener("click", showTooltip);
        identifyMobileDevice();
	});
</script>
<template>
	<Transition>
		<div v-show="activeTooltip" :class="['tooltip']" ref="tooltip">
			<button 
				v-if="isMobile" 
				@click="hideTooltip" 
				class="tooltip__btn-close">
				<svg width="16" height="16"><use href="#x"></use></svg>
			</button>
			<div class="tooltip__holder">
				<slot></slot>
			</div>
		</div>
	</Transition>
</template>
<style lang="scss" scoped>
	.v-enter-active,
	.v-leave-active {
		transition: all 0.25s ease-out;
	}

	.v-enter-from {
		opacity: 0;
		transform: translate(-50%, 10px);
	}
	.v-leave-to {
		opacity: 0;
		transform: translate(-50%, 10px);
	}
</style>
